// ets_tracing: off
import { pipe } from "@effect-ts/core/Function";
import { interpreter } from "../../HKT/index.mjs";
import { memo } from "../../Utils/index.mjs";
import { decoderApplyConfig, DecoderType, DecoderURI } from "../base/index.mjs";
import { makeDecoder } from "../common/index.mjs";
export const decoderRecursiveInterpreter = /*#__PURE__*/interpreter()(() => ({
  _F: DecoderURI,
  recursive: (a, cfg) => {
    const get = memo(() => a(res));

    const res = env => new DecoderType((getDecoder => decoderApplyConfig(cfg === null || cfg === void 0 ? void 0 : cfg.conf)(makeDecoder((u, c) => getDecoder().validate(u, c), "recursive", (cfg === null || cfg === void 0 ? void 0 : cfg.name) || "Recursive"), env, {}))(() => get()(env).decoder));

    return res;
  }
}));
//# sourceMappingURL=recursive.mjs.map